var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"switchButton"},[_c('el-switch',{on:{"change":_vm.change},model:{value:(_vm.value.val),callback:function ($$v) {_vm.$set(_vm.value, "val", $$v)},expression:"value.val"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }